var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5665 3.01066C9.71637 3.2391 6.00006 7.40614 6.00006 12.2286V16.5892L4.40982 19.7884C4.40702 19.7942 4.40429 19.8001 4.40162 19.806C3.76186 21.1665 4.79748 22.8001 6.30123 22.8001H11.4001C11.4001 24.7776 13.0225 26.4001 15.0001 26.4001C16.9776 26.4001 18.6001 24.7776 18.6001 22.8001H23.6977C25.2015 22.8001 26.2384 21.1668 25.5985 19.806C25.5958 19.8001 25.5931 19.7942 25.5903 19.7884L24.0001 16.5892V12.0001C24.0001 6.89639 19.718 2.76813 14.5665 3.01066ZM14.6508 4.80831C18.8029 4.61284 22.2001 7.89743 22.2001 12.0001V16.8001C22.1999 16.9392 22.232 17.0763 22.2938 17.2009L23.9696 20.5735C24.0774 20.8045 23.9527 21.0001 23.6977 21.0001H6.30123C6.04627 21.0001 5.9226 20.8049 6.03052 20.5735V20.5724L7.70631 17.2009C7.76809 17.0763 7.80018 16.9392 7.80006 16.8001V12.2286C7.80006 8.32831 10.7877 4.99027 14.6508 4.80831ZM13.2001 22.8001H16.8001C16.8001 23.8046 16.0045 24.6001 15.0001 24.6001C13.9956 24.6001 13.2001 23.8046 13.2001 22.8001Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.51f2f8a1324a5e3ea0c2a115211b24bd.svg";
export { ForwardRef as ReactComponent };